import {Drawer, TextField, Box, Button} from "@mui/material";
import { useCookies } from "react-cookie";
import { useState, useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material";

export default function NoteDrawer({ open, onClose, note, reload, forceEdit, dark }) {

    const [cookies] = useCookies(["token"]);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [editMode, setEditMode] = useState(false);

    const theme = createTheme({
        palette: {
            mode: dark ? "dark" : "light",
            primary: {
                main: "#6fb8af"
            }
        }
    });

    useEffect(() => {
        if (note) {
            setTitle(note.title);
            setContent(note.content);
            setEditMode(forceEdit ? true : false); // <--- mode lecture par défaut
        } else {
            setTitle("");
            setContent("");
            setEditMode(true); // <--- création = édition directe
        }
    }, [note, forceEdit]);



    async function saveNote() {
        const method = note ? "PUT" : "POST";
        const url = note
            ? `https://api.industriegaming.fr/api/quebec/notes/${note.id}`
            : "https://api.industriegaming.fr/api/quebec/notes";

        await fetch(url, {
            method,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + cookies.token
            },
            body: JSON.stringify({ title, content })
        });

        reload();
        onClose();
    }

    return (
        <ThemeProvider theme={theme}>
            <Drawer anchor="right" open={open} onClose={onClose}>
                <Box sx={{ width: "40vw", p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                    {!editMode ? (
                        <>
                            <div className="note-header">
                                <h2 className="note-title">{title}</h2>

                                <div className="note-meta">
                                    <p className="note-author">{note?.user?.name || note?.user?.email}</p>
                                    <p className="note-date">
                                        {note?.createdAt ? new Date(note.createdAt).toLocaleDateString("fr-FR") : ""}
                                    </p>
                                </div>
                            </div>

                            <p className="note-content">{content}</p>


                            {/*<Button variant="contained" onClick={() => setEditMode(true)}>*/}
                            {/*    Modifier*/}
                            {/*</Button>*/}
                        </>
                    ) : (
                        <>
                            <h2>{note ? "Modifier la note" : "Nouvelle note"}</h2>
                            <TextField
                                label="Titre"
                                fullWidth
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />

                            <TextField
                                label="Contenu"
                                fullWidth
                                multiline
                                minRows={6}
                                value={content}
                                onChange={(e) => setContent(e.target.value)}
                            />

                            <Button variant="contained" onClick={saveNote}>
                                Enregistrer
                            </Button>
                        </>
                    )}

                </Box>
            </Drawer>
        </ThemeProvider>
    );
}
